<ng-container *ngIf="action$ | async"></ng-container>

<div class="groove-select-wrapper flex flex-row space-x-2 items-center flex-1">
  <mat-form-field floatLabel="never" appearance="fill" class="flex-1">
    <mat-select
      i18n-placeholder
      [disabled]="disabled || !editable"
      placeholder="Нет"
      #select
      [ngModel]="selected"
      (selectionChange)="selectionChange($event.value)"
      panelClass="groove-select-panel">
      <mat-select-trigger>
        <span *ngIf="selected">{{ selected.designation }}</span>
        <span *ngIf="!selected" i18n>Нет</span>
      </mat-select-trigger>

      <mat-option i18n [value]="undefined">Нет</mat-option>

      <mat-option [value]="selected" *ngIf="selected">{{ selected.designation }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="flex flex-col gap-0.5 justify-center items-center">
    <button
      i18n-matTooltip
      [disabled]="!editable"
      mat-icon-button
      class="other-groove-btn"
      (click)="openGrooveListDialog()"
      matTooltip="Изменить">
      <mat-icon class="s-16">settings</mat-icon>
    </button>
    <csl-groove-info
      [data]="{ position: position, groove: selected }"
      class="flex flex-col justify-center items-center">
    </csl-groove-info>
  </div>
</div>
